
import React, { Component } from "react";
import { BreadCumb, NewDocTable, NavBar, TimeOut } from "../../components";
import config from "../../config";
import moment from "moment";
import { ApiClient } from "../../libs/apiClient";
import { DISPATCH_ID, SERVICE_RESPONSE } from "../../libs/utils/Const";
import { connect } from "react-redux";
const apiClient = ApiClient.getInstance();
const today = moment(new Date()).format("YYYYMMDD");

const headersDataTable = [
    { title: "Serie", value: true },
    { title: "Estatus", value: true },
    { title: "Num.Doc", value: true },
    { title: "Fecha Cont.", value: true },
    { title: "Comentarios", value: true },
];

class GoodsReceiptProd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + "currentUser")),
        };
    }

    async componentDidMount() {
        const date = {
            dateInit: today,
            dateFinal: today,
        };

        await this.searchDocuments(date);
    }

    searchDocuments = async (newDate) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user } = this.state;

        const data = {
            dateInit: newDate.dateInit,
            dateFinal: newDate.dateFinal,
            switch1: newDate.docStatus || "---",
            table: "OIGN",
            docNumSearch: newDate.docNumSearch || "--",
        };

        enableSpinner(true);
        const response = await apiClient.getDocumentsList_PROD(data);
        enableSpinner(false);

        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            // this.setState({
            //     data: response.data ?? [],
            // });

            if (response?.data?.length === 0) {
                this.setState({
                    data: [],
                });
                return showAlert({ type: 'info', timeOut: 4000, message: "No se encontraron resultados correspondientes a la búsqueda." });
            }

            let table = {
                name: "OIGN",
                complement: "IGN1",
                docSubType: "--",
                docType: "59"
            };
            let dataSerie = {
                docType: table?.docType,
                docSubType: table?.docSubType
            };

            enableSpinner(true);
            const seriesResponse = await apiClient.getSeries(dataSerie);
            enableSpinner(false);
            let ValidateSeries = _user?.U_FMB_SeriesInventoryGenEntries || "";

            if (!_user || ValidateSeries === "") {
                this.setState({
                    data: [],
                });
                return showAlert({ type: 'warning', message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador", timeOut: 5000 });
            }
            let seriesUsers = ValidateSeries?.split("|");
            let newArraySeries = [];

            for (let index = 0; index < seriesUsers?.length; index++) {
                const serieUser = seriesUsers[index];
                for (let index = 0; index < seriesResponse?.data?.length; index++) {
                    const serieResponse = seriesResponse.data[index];
                    if (String(serieResponse.Series) === String(serieUser) && serieResponse.DocSubType === table.docSubType) {
                        newArraySeries.push(serieResponse);
                    }
                }
            }

            if (newArraySeries?.length === 0) {
                return showAlert({ type: 'warning', message: "El usuario no tiene serie permitida de escritura y lectura", timeOut: 5000 });
            }

            let newDocumentsfilterSeries = [];
            for (let index = 0; index < response?.data?.length; index++) {
                const document = response?.data[index];
                for (let index = 0; index < newArraySeries.length; index++) {
                    const serie = newArraySeries[index];
                    if (String(document.Series) === String(serie.Series)) {
                        newDocumentsfilterSeries.push(document);
                    }
                }
            }

            this.setState({
                data: newDocumentsfilterSeries ?? [],
            });
        }
    };

    render() {
        const { headers, data, _user } = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <BreadCumb subitem1={"RECIBO DE PRODUCCIÓN"} url1={"#"} />
                <TimeOut />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <a id="linkOrdProv" className="text-muted">
                            &nbsp;RECIBO DE PRODUCCIÓN
                        </a>
                    </h2>
                    <NewDocTable
                        headers={headers}
                        view={"goodsReceiptProd"}
                        data={data}
                        search={this.searchDocuments}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (store) => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = (dispatch) => {
    return {
        enableSpinner: (value) => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GoodsReceiptProd)